document.addEventListener('DOMContentLoaded', function() {
  function forceShowMedia(mediaId) {
    // If we got passed a variant ID instead of a media ID, try to find the media ID
    if (mediaId && mediaId.toString().length > 15) {
      console.log('Warning: Received a variant ID instead of a media ID. Finding featured media...');
      // Try to find the first media ID
      var firstMedia = document.querySelector('[data-media-id]');
      if (firstMedia) {
        mediaId = firstMedia.getAttribute('data-media-id');
        console.log('Using first available media ID: ' + mediaId);
      }
    }
    
    // Debug output
    console.log('Showing media with ID: ' + mediaId);
    
    // Hide all wrappers
    var allWrappers = document.querySelectorAll('.product-single__photo-wrapper');
    allWrappers.forEach(function(wrapper) {
      wrapper.classList.add('hide');
      wrapper.style.display = 'none';
      
      // Also hide all inner photo elements - CRITICAL!
      var innerElements = wrapper.querySelectorAll('.product-single__photo');
      innerElements.forEach(function(element) {
        element.classList.add('hide');
        element.style.display = 'none';
      });
    });
    
    // Try multiple ways to find the right wrapper
    var targetWrapper = document.querySelector(`.product-single__photo-wrapper[data-media-id="${mediaId}"]`) ||
                        document.getElementById(`FeaturedImageZoom-product-template-${mediaId}-wrapper`) ||
                        Array.from(allWrappers).find(wrapper => 
                          wrapper.id.includes(mediaId) || wrapper.querySelector(`[id*="${mediaId}"]`));
    
    if (targetWrapper) {
      // Show the wrapper
      targetWrapper.classList.remove('hide');
      targetWrapper.style.display = 'block';
      
      // CRITICAL: Show all inner elements with product-single__photo class
      var innerElements = targetWrapper.querySelectorAll('.product-single__photo');
      innerElements.forEach(function(element) {
        element.classList.remove('hide');
        element.style.display = 'block';
      });
      
      // Also try to directly find the inner element by ID
      var innerPhotoElement = document.getElementById(`FeaturedImageZoom-product-template-${mediaId}`);
      if (innerPhotoElement) {
        innerPhotoElement.classList.remove('hide');
        innerPhotoElement.style.display = 'block';
      }
      
      // Process special media if needed
      processSpecialMedia(targetWrapper);
      
      // Double-check after a short delay to make sure elements stay visible
      setTimeout(function() {
        if (targetWrapper.classList.contains('hide') || targetWrapper.style.display === 'none') {
          targetWrapper.classList.remove('hide');
          targetWrapper.style.display = 'block';
        }
        
        innerElements.forEach(function(element) {
          if (element.classList.contains('hide') || element.style.display === 'none') {
            element.classList.remove('hide');
            element.style.display = 'block';
          }
        });
        
        if (innerPhotoElement && (innerPhotoElement.classList.contains('hide') || innerPhotoElement.style.display === 'none')) {
          innerPhotoElement.classList.remove('hide');
          innerPhotoElement.style.display = 'block';
        }
      }, 100);
      
      // Update active thumbnail border
      updateActiveThumbnail(mediaId);
    } else {
      console.error('Could not find wrapper for media ID: ' + mediaId);
    }
  }
  
  // New function to update the active thumbnail border
  function updateActiveThumbnail(mediaId) {
    // Remove active class from all thumbnails
    const allThumbnails = document.querySelectorAll('.product-single__thumbnail');
    allThumbnails.forEach(function(thumb) {
      thumb.classList.remove('active-thumb');
    });
    
    // Find and add active class to the current thumbnail
    const currentThumb = document.querySelector(`.product-single__thumbnail[data-thumbnail-id="${mediaId}"]`) || 
                        document.querySelector(`.product-single__thumbnail[data-media-id="${mediaId}"]`);
    if (currentThumb) {
      currentThumb.classList.add('active-thumb');
    }
  }

  function processSpecialMedia(wrapper) {
    var video = wrapper.querySelector('video');
    if (video) video.load();
    
    var iframe = wrapper.querySelector('iframe');
    if (iframe) iframe.setAttribute('src', iframe.getAttribute('src'));
    
    var modelViewer = wrapper.querySelector('model-viewer');
    if (modelViewer) {
      setTimeout(function() {
        if (typeof modelViewer.dismissPoster === 'function') {
          modelViewer.dismissPoster();
        }
      }, 100);
    }
  }

  function setupThumbnails() {
    var thumbnails = document.querySelectorAll('.product-single__thumbnail');
    thumbnails.forEach(function(thumbnail) {
      var mediaId = thumbnail.getAttribute('data-thumbnail-id') || 
                   thumbnail.getAttribute('data-media-id');
      
      if (!mediaId) return;
      
      var overlay = document.createElement('div');
      overlay.setAttribute('data-media-target', mediaId);
      overlay.style.position = 'absolute';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.zIndex = '10';
      overlay.style.cursor = 'pointer';
      
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        forceShowMedia(this.getAttribute('data-media-target'));
        return false;
      });
      
      var parent = thumbnail.parentElement;
      parent.style.position = 'relative';
      parent.appendChild(overlay);
    });
  }

  function setupVariantListeners() {
    var selectors = document.querySelectorAll('.single-option-selector');
    selectors.forEach(function(selector) {
      selector.addEventListener('change', function() {
        // When a variant changes, find the associated media to display
        setTimeout(function() {
          // Get the selected variant
          var variantSelect = document.querySelector('#ProductSelect-product-template');
          if (!variantSelect) return;
          
          var selectedVariantId = variantSelect.value;
          console.log('Selected variant ID:', selectedVariantId);
          
          // Try to find the variant's featured media in the hidden JSON data
          var productJson = null;
          var productJsonEl = document.getElementById('ProductJson-product-template');
          if (productJsonEl) {
            try {
              productJson = JSON.parse(productJsonEl.textContent);
              console.log('Found product JSON data');
            } catch (e) {
              console.error('Error parsing product JSON:', e);
            }
          }
          
          // If we have the product JSON, find the selected variant
          if (productJson && productJson.variants) {
            var selectedVariant = productJson.variants.find(v => v.id.toString() === selectedVariantId.toString());
            
            if (selectedVariant) {
              console.log('Found selected variant in JSON');
              
              // If the variant has a featured_media object
              if (selectedVariant.featured_media && selectedVariant.featured_media.id) {
                console.log('Variant has featured media ID:', selectedVariant.featured_media.id);
                forceShowMedia(selectedVariant.featured_media.id);
                return;
              }
            }
          }
          
          // Fallback: use the first image if we can't find the variant's featured media
          console.log('Using fallback: showing first image thumbnail');
          var firstImageThumb = document.querySelector('.product-single__thumbnail[data-media-type="image"]') || 
                                document.querySelector('.product-single__thumbnail');
          
          if (firstImageThumb) {
            var mediaId = firstImageThumb.getAttribute('data-thumbnail-id') || 
                         firstImageThumb.getAttribute('data-media-id');
            if (mediaId) {
              forceShowMedia(mediaId);
            }
          }
        }, 250);
      });
    });
  }

  function addStyles() {
    var style = document.createElement('style');
    style.textContent = `
      .product-single__media {
        position: relative;
        height: 0;
        padding-bottom: 100%;
        width: 100%;
      }
      
      .product-single__media video,
      .product-single__media iframe,
      .product-single__media model-viewer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      
      model-viewer {
        background-color: #f5f5f5;
      }
      
      /* Force media display styles */
      .product-single__photo-wrapper.force-show,
      .product-single__photo.force-show {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
      }
      
    `;
    //document.head.appendChild(style);
  }

  function init() {
    addStyles();
    setupThumbnails();
    setupVariantListeners();
    
    // Show the first IMAGE (not model) by default
    console.log('Initializing gallery - looking for first image to display');
    
    // First, check if we already have a selected variant with a featured media
    var selectedVariantId = null;
    var variantSelect = document.querySelector('#ProductSelect-product-template');
    if (variantSelect) {
      selectedVariantId = variantSelect.value;
      console.log('Found selected variant ID:', selectedVariantId);
    }
    
    // Try to get the featured media ID for this variant from the product JSON
    if (selectedVariantId) {
      var productJsonEl = document.getElementById('ProductJson-product-template');
      if (productJsonEl) {
        try {
          var productJson = JSON.parse(productJsonEl.textContent);
          var selectedVariant = productJson.variants.find(v => v.id.toString() === selectedVariantId.toString());
          
          if (selectedVariant && selectedVariant.featured_media && selectedVariant.featured_media.id) {
            console.log('Using featured media ID from selected variant:', selectedVariant.featured_media.id);
            forceShowMedia(selectedVariant.featured_media.id);
            return; // Exit if we successfully showed the variant's media
          }
        } catch (e) {
          console.error('Error parsing product JSON:', e);
        }
      }
    }
    
    // If we get here, we need to find the first IMAGE thumbnail (not 3D model or video)
    console.log('Looking for first image thumbnail');
    var firstImageThumb = document.querySelector('.product-single__thumbnail[data-media-type="image"]') || 
                          document.querySelector('.product-single__thumbnail:not([data-media-type="model"]):not([data-media-type="video"]):not([data-media-type="external_video"])');
    
    if (firstImageThumb) {
      console.log('Found first image thumbnail');
      var mediaId = firstImageThumb.getAttribute('data-thumbnail-id') || 
                   firstImageThumb.getAttribute('data-media-id');
      if (mediaId) {
        console.log('Using media ID from first image thumbnail:', mediaId);
        forceShowMedia(mediaId);
        return;
      }
    }
    
    // Last resort: try any thumbnail
    console.log('Last resort: looking for any thumbnail');
    var anyThumb = document.querySelector('.product-single__thumbnail');
    if (anyThumb) {
      var thumbMediaId = anyThumb.getAttribute('data-thumbnail-id') || 
                         anyThumb.getAttribute('data-media-id');
      if (thumbMediaId) {
        console.log('Using media ID from any thumbnail:', thumbMediaId);
        forceShowMedia(thumbMediaId);
      }
    }
  }
  
  init();
});